/**
 * FM 店舗の一覧ページのルートコンポーネント
 */
import { defineComponent } from 'vue'
import PointsService from "@/services/PointsService.ts"
import PointsPage from "@/organizations/_default/points"

export default defineComponent({
  extends: PointsPage,
  setup(props, context) {
    const page = PointsPage.setup(props, context)
    const is_new_open = storelocator?.path?.id == "new-open"

    if (is_new_open) {
      storelocator.messages.points_title = `${storelocator.messages.new_open_points_title}`
      storelocator.messages.points_title_with_area = `${storelocator.messages.new_points_title_with_area}`      
      
      PointsService.pagination.limit = 500

      // 新店の場合は都道府県から探す以外非表示
      storelocator.points.default.filters.hide.enabled = false
      storelocator.points.default.filters.filter.enabled = false
      storelocator.points.default.filters.keywords.enabled = false
      storelocator.points.default.filters.location.enabled = false
      storelocator.points.default.filters.places.enabled = false      
    }

    const new_open_note = storelocator.messages.new_open_note || ""


    //キャンペーンバナー画像
    const campaignBanner = storelocator?.campaign?.extra_config?.banners?.find(banner => banner.key === "points_banner")
    const campaignBannerImage = {
      key: campaignBanner?.key,
      url: campaignBanner?.image?.url,
      path: storelocator?.campaign?.path
    }

    return {
      ...page,
      is_new_open,
      new_open_note,
      campaignBannerImage
    }
  }
})